import { SettingsManagerFont } from '../types/SettingsManager.type.fonts'

export function applyFontOverride(font: SettingsManagerFont | string | null) {
  const fontEnum = typeof font === 'string' ? stringToSettingsManagerFont(font) : font
  if (!fontEnum) {
    // invalid font
    return
  }
  const htmlElement = document.documentElement

  if (fontEnum === SettingsManagerFont.SulSans) {
    htmlElement.classList.add('ts-font-sulsans-active')
  } else {
    htmlElement.classList.remove('ts-font-sulsans-active')
  }
}

// type safe conversion from string to SettingsManagerFont enum
function stringToSettingsManagerFont(value: string): SettingsManagerFont | null {
  if (Object.values(SettingsManagerFont).includes(value as SettingsManagerFont)) {
    return value as SettingsManagerFont
  }
  return null
}
